<template lang="pug">
	.page
			.wrapper
				.contacts
					.wrapper.wrapper_min
						.contacts__red-title(data-aos="fade-up") надійні партнери FMC
						.contacts__title(data-aos="fade-up") Офіційні дистриб’ютори
					.list(data-aos="fade-up" data-aos-delay="200")
						.card(v-for="(card, index) in distributors" :key="index")
							.card__bg(:style="{ backgroundImage: 'url(' + card.logo + ')'}")
								a.card__row( v-if="card.site_url" :href="card.site_url" )
									.card__link(v-text="card.site_url")
									.card__icon
										img(src="@/assets/img/planet.svg")
								a.card__row( v-if="card.email" :href="'mailto:' + card.email" )
									.card__link(v-text="card.email")
									.card__icon
										img(src="@/assets/img/mail.svg")
								a.card__row( v-if="card.phone" :href="'tel:' + card.phone" )
									.card__link(v-text="card.phone")
									.card__icon.card__icon__phone
										img(src="@/assets/img/phone.svg")
</template>

<script>

  let collectionSlug = 'distributors';

	import AOS from 'aos';

	import {mapState} from 'vuex';

	export default {
		name: collectionSlug,
		metaInfo: function() {
			return {
				title: 'Дистриб’ютори'
			}
		},
		data: function(){
			return {
				activeRegion: ''
			}
		},
		created() {
			if (!this[collectionSlug].length) this.$store.dispatch('GET_COLLECTION', collectionSlug);
		},
		mounted() {
			this.$nextTick(() => {
				AOS.init({
					once: true,
					disabled: 'mobile',
					duration: 1000
				});
			})
		},
		computed: {
			...mapState([
				collectionSlug,
			])
		}
	}

</script>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';

	.contacts {
		margin-bottom: 100px;
		padding-top: 18px;

		&__red-title {
			@include kit('featureSubtitle');
			margin-left: -7px!important;
		}

		&__title {
			@include kit('distributorsTitle');
			margin-left: -7px!important;
		}
	}

	.list {
		font-size: 0;
		margin-top: 74px;
		margin-bottom: -24px;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: center;
	}

	.card {
		display: inline-block;
		vertical-align: bottom;
		width: 25%;
		min-width: 305px;
		height: 252px;
		margin-bottom: 22px;
		padding-right: 20px;
		
		&__bg {
			background-size: contain;
			background-position: top;
			background-repeat: no-repeat;
			background-color: #ffffff;
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: flex-end;
			
			&:hover {
				box-shadow: 0 25px 50px rgba(51, 51, 51, 0.1);
				.card__row {
					border-color: #E9E9E9;
					opacity: 1;
				}
				.card__icon {
					border-color: #E9E9E9;
				}
			}
		}
		
		&__row {
			height: 32px;
			border-top: 1px solid #F2F2F2;
			display: flex;
			align-items: center;
			justify-content: space-between;
			@include kit('distributorsText');
			padding-left: 20px;
			&:hover {
				background-color: #F2F2F2;
			}
		}
		
		&__link {
			color: #333333;
		}
		
		&__icon {
			width: 32px;
			height: 100%;
			border-left: 1px solid #F2F2F2;
			padding: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
	}

	@media screen and (max-width: 1200px) {
		.list {
			justify-content: center;
		}
		 .card {
			 background-color: transparent;
		 }
		}
	
	@media (max-width: 649px) {
		.card {
			padding-right: 0;
      min-width: auto;
      width: 95%;
		}
	}

</style>
